import { NETWORK_URLS } from '../constants/NetworkConstants';
import { zenManageUrl, headerHelper } from '../helper/Utility';

export default class OrderService {

  static getAll = async (page = 1, rowsPerPage = 50) => {
    let encodedUrl = zenManageUrl() + NETWORK_URLS.orders + "?page=" + page + "&limit=" + rowsPerPage;
    let token = 'ZQmkHtH4Fr6quQ0QMGVMqTomi5sp3wBP';

    try {
      let response = await fetch(encodedUrl, { method: 'GET', headers: headerHelper(token) });
      let responseJson = await response.json();
      return { status: response.status, json: responseJson };
    } catch (e) {
      console.log(e);
      return [];
    }
  }

  static getOrder = async (orderId) => {
    let encodedUrl = zenManageUrl() + NETWORK_URLS.orders;

    try {
      const response = await fetch(encodedUrl + "/" + orderId, { method: 'GET', headers: headerHelper() });
      const responseJson = await response.json();
      return { status: response.status, json: responseJson };
    } catch (e) {
      console.log(e);
      return [];
    }
  }
}
